export default "__VITE_ASSET__dfHsIhYv__"